import { Cell, Grid, TextField } from 'bold-ui'

export const EvolucoesOdontoTableHeader = (props: { onChange(filter: string): void }) => {
  const { onChange } = props

  return (
    <Grid alignItems='flex-start' gap={1}>
      <Cell md={7} lg={6}>
        <TextField
          placeholder='Pesquise por procedimento, local ou profissional'
          icon='zoomOutline'
          onChange={(e) => onChange(e.currentTarget.value)}
        />
      </Cell>
    </Grid>
  )
}
